<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 md:pb-16 rounded-b-md">
        <div class="text-center relative">
          <button
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate"
            @click="$router.go(-1)"
          >
            <BackIcon />
          </button>
          <h2 class="mt-5 mb-5 text-sm sm:text-2xl font-semibold uppercase text-primary">
            {{ $t('action.title') }}
          </h2>
        </div>
        <div class="flex flex-wrap items-center">
          <div
            class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-8 w-full"
            style="min-height: 300px"
          >
            <div
              v-if="isLoading"
              class="flex justify-center items-center w-full pt-12"
            >
              <div
                class="spinner w-12 h-12 animate-spin"
              >
                <SpinnerIcon />
              </div>
            </div>
            <transition
              name="fade"
            >
              <ActionList
                v-if="!isLoading"
                :actions="actions"
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as Sentry from '@sentry/browser';
import { mapActions, mapState } from 'vuex';
import ActionList from '@/components/Action/ActionList';
import AccountWidget from '@/components/AccountWidget';
import BackIcon from '@/assets/icons/back.svg';
import SpinnerIcon from '@/assets/icons/spinner.svg';

export default {
  name: 'Actions',
  components: {
    ActionList,
    AccountWidget,
    BackIcon,
    SpinnerIcon,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState('action', ['actions']),
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    ...mapActions('action', ['fetchActions']),
    async fetchData() {
      try {
        this.isLoading = true;
        await this.fetchActions();
      } catch (e) {
        console.error(e);
        Sentry.captureException(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
